import * as React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "sweetalert2/dist/sweetalert2.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/main.css";

import Shorturl from "./page/Shorturl";
import HandleRedirect from "./page/HandleRedirect";

function App() {
  return (
    <Router basename={"/s/"}>
      <Routes>
        <Route exact path="/" element={<Shorturl />} />
        <Route exact path="/:urlId" element={<HandleRedirect />} />
      </Routes>
    </Router>
  );
}

export default App;
